// extracted by mini-css-extract-plugin
export default {"cls1":"Feed-cls1_tvC","cls2":"Feed-cls2_l8R Feed-cls1_tvC"};